@if (isVisible()) {
  <button
    mat-flat-button
    color="secondary-transparent"
    type="button"
    class="flex items-center gap-1 text-sm font-medium transition-colors duration-150 mat-tiny-button"
    (click)="onToggle($event)"
  >
    <div class="flex items-center gap-1">
      <span [class.text-shikenso-pink-base]="isOpen()">
        {{ 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.advanced.button' | translate }}
      </span>
      <app-icon src="/icons/settings.svg" [size]="16" />
    </div>
  </button>
}
